import { ReactElement } from "react"
import { RouteData } from "src/model"
import access from "./localAccess"

const routeData = (path: string, name: string, component: ReactElement<any, any>): RouteData => {
    return { 
        routeProps: {
            path,
            element: component
        },
        name
    }
}

const toTitleCase = (text: string) => {
    text = text.toLowerCase()
    return text[0].toUpperCase() + text.substring(1, text.length)
}

const splitCamelCase = (text: string, isTitleCase?: boolean) => {
    let result = text.replace(/([a-z])([A-Z])/g, '$1 $2')
    result = isTitleCase ? result[0].toUpperCase() + result.substring(1) : result 
    return result
}

const getPageTitle = () => {
    let route = toTitleCase(window.location.href.split('/').pop()!)
    let pageTitle = route ? route.split('-').join(' ') : 'Hydra'
    return pageTitle
}

export const erroMessage = (text: any) => {
    const isOnline = access.getInternetStatus()
    return !isOnline ? 'No Internet Connection' : `Message: ${text || 'An error occured'}`
}

export const requestMessage = (resp: any, text = '') => {
    return resp.message || text || 'Something went wrong'
}

export const catchErrMsg = (err: any) => {
    let message = err?.response?.data?.message
    
    if (err.response?.status === 500) message = 'Something went wrong (Server)'
    if (err.response?.status === 401) {
        message = 'Session has expired'
        if (access.getLogoutHandler()) access.getLogoutHandler()()
    }
    return message 
}

export const moneyFormat = (val: number|string) => {
    var formatter = new Intl.NumberFormat('en-US')
    return formatter.format(Number(val))
}

export const loglite = (data: any, description?: string) => {
    if (description) console.log(`====== ${description} =======`)
    console.log(data)
}

const downloadReportCSV = (data: any, fileName = 'downloaded-crendly-report') => {
    const convertArrayToTable =  async (apiArray: Array<any>, fileName: string) => {
        //use keys from the first array object to form table column headers
        const tableHeaders = `<tr>${Object.keys(apiArray[0]).map(key =>   `<td>${key}</td>`).join('')}</tr>`;
        //now loop through all array objects to form table rows
        const tableRows = apiArray.map(obj =>
           [`<tr>
              ${Object.keys(obj).map(key => `<td>${obj[key] === null ||    obj[key] === '' ? '' : obj[key]}</td>`).join('')}
           <tr/>`]).join('');
        const table = `<table>${tableHeaders}${tableRows}</table>`.trim();
     
     
        const xmlTable = createXMLTable(table, fileName);
        const downloadURL = createFileUrl(xmlTable);
        downloadFile(downloadURL, fileName);
    }

    const createXMLTable = (table: string, fileName: string) => {
        const xmlTable = `
              <html xmlns:o="urn:schemas-microsoft-com:office:office xmlns:x="urn:schemas-microsoft-com:office:excel"
             xmlns="http://www.w3.org/TR/REC-html40"
              >
                 <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/>
                 <head>
                    <xml>
                      <x:ExcelWorkbook>
                          <x:ExcelWorksheets>
                              <x:ExcelWorksheet>
                                  <x:Name>${fileName}</x:Name>
                                  <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                              </x:ExcelWorksheet>
                          </x:ExcelWorksheets>
                      </x:ExcelWorkbook>
                    </xml>
                 </head>
                 <body>
                   ${table}
                 </body>
              </html> `
        return xmlTable;
    }

    const createFileUrl = (xmlTable: string) => {
        const tableBlob = new Blob([xmlTable], {type: 'application/vnd.ms-excel;base64,' });
        const downloadURL = URL.createObjectURL(tableBlob);
        return downloadURL;
    }

    const downloadFile = (downloadURL: string, fileName: string) => {
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.download = fileName;
        downloadLink.href = downloadURL;
        downloadLink.click();
    }

    convertArrayToTable(data, fileName)
}

export default {
    routeData,
    toTitleCase,
    getPageTitle,
    requestMessage,
    catchErrMsg,
    erroMessage,
    splitCamelCase,
    moneyFormat,
    downloadReportCSV
}